import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { Layout } from '../components/ui/Layout';
import { Spinner } from '../components/ui/Spinner';
import { loadJWT } from '../helpers/loadJWT';
import { url } from '../api/api';

const defaultReturnPath = 'admin/inicioBack/inicio';

const pageStyle = {
  padding: '24px',
  width: '100%',
  boxSizing: 'border-box',
};

const iframeStyle = {
  width: '100%',
  minHeight: 'calc(100vh - 136px)',
  border: 0,
  borderRadius: '12px',
  backgroundColor: '#fff',
};

const errorTextStyle = {
  color: '#c62828',
  fontWeight: 500,
};

const GestorDocumental = () => {
  const [iframeSrc, setIframeSrc] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadGestorDocumentalUrl = async () => {
      try {
        const { token } = loadJWT();
        const { data } = await url.get('/integraciones/gestor-documental-url', {
          params: { return: defaultReturnPath },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (isMounted) {
          setIframeSrc(data.url);
        }
      } catch (requestError) {
        if (isMounted) {
          setError(requestError?.response?.data?.error?.message || 'No se ha podido cargar el gestor documental');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadGestorDocumentalUrl();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Gestor Documental</title>
      </Helmet>

      <Box style={pageStyle}>
        {loading && <Spinner />}
        {!loading && error && <Typography style={errorTextStyle}>{error}</Typography>}
        {!loading && !error && iframeSrc && <iframe title="Gestor Documental" src={iframeSrc} style={iframeStyle} />}
      </Box>
    </Layout>
  );
};

export default GestorDocumental;
